import { render, staticRenderFns } from "./form_affiliates_period_component.vue?vue&type=template&id=0920b082&scoped=true"
import script from "./form_affiliates_period_component.vue?vue&type=script&lang=js"
export * from "./form_affiliates_period_component.vue?vue&type=script&lang=js"
import style0 from "./form_affiliates_period_component.vue?vue&type=style&index=0&id=0920b082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920b082",
  null
  
)

export default component.exports